import React from 'react';
import { inject, observer } from 'mobx-react'

import { Form, Icon, Input, Button, Checkbox, Alert } from 'antd';

import config from '../../config'
import './index.less'
const FormItem = Form.Item;

@inject('admin')
@observer
class LoginFrom extends React.Component {

    state = {
        isFailure : false
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if(!err) {
                this.props.admin.login(values)
            }
        })
    }

    renderMessage = content => {
        return <Alert style={{ marginBottom: 24 }} message={content} type="error" showIcon />;
    };

    render() {
        const error = this.state.isFailure;
        const { getFieldDecorator } = this.props.form;
        return (
            <div id="login-form">
                <Form onSubmit={this.handleSubmit} className="login-form">
                    { error && this.renderMessage('账户或密码错误')}
                    <FormItem>
                    {getFieldDecorator('username', {
                        rules: [{ required: true, message: 'Please input your username!' }],
                    })(
                        <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Username" />
                    )}
                    </FormItem>
                    <FormItem>
                    {getFieldDecorator('password', {
                        rules: [{ required: true, message: 'Please input your Password!' }],
                    })(
                        <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Password" />
                    )}
                    </FormItem>
                    <FormItem>
                    {getFieldDecorator('remember', {
                        valuePropName: 'checked',
                        initialValue: true,
                    })(
                        <Checkbox>Remember me</Checkbox>
                    )}
                    <a className="login-form-forgot" href="">Forgot password</a>
                    <Button type="primary" htmlType="submit" className="login-form-button">
                        Log in
                    </Button>
                    Or <a href={config["CLIENT_URL"] + "/register"}>register now!</a>
                    </FormItem>
                </Form>
            </div>
        )
    }
}

export default  Form.create()(LoginFrom);